import { jsx as _jsx } from "react/jsx-runtime";
const SvgLolDrakeOcean = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 15,
	viewBox: "0 0 16 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M5.78557 7.40344C5.78557 7.40344 7.22833 5.19662 9.29663 7.40344C11.3649 9.61026 9.67329 14.4653 5.59724 13.3306C1.68934 12.2415 0.337382 6.03199 2.59065 3.46667C2.7134 3.32632 2.94209 3.38212 2.98413 3.56306C3.09343 4.02472 3.31035 4.77724 3.6517 5.25919C3.6517 5.25919 5.15668 0.214789 10.2988 1.81283C15.0643 4.16677 12.8077 7.71967 12.8077 7.71967C12.8077 7.71967 14.2689 8.64974 12.9456 11.2979C12.8766 11.4366 12.6681 11.3926 12.6597 11.237C12.6496 11.0426 12.6294 10.8346 12.5857 10.6705C12.5504 10.5386 12.3705 10.5217 12.3099 10.6452C12.0628 11.1508 11.4826 12.2923 10.9782 12.9365C10.8773 13.0651 10.6738 12.9535 10.7293 12.7979C11.2825 11.2168 12.4546 6.87583 9.06794 5.93392C9.06794 5.93392 9.25627 4.31559 10.1761 3.66453C10.1761 3.66453 8.46258 3.20287 7.01982 4.8212V5.87135C7.01814 5.86797 5.84779 6.52071 5.78557 7.40344Z",
		fill: "currentColor"
	})
});
export default SvgLolDrakeOcean;
